import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from "../utils/constants";

export const apiAuth = {
  resetPassword: (value) =>
    AxiosInterceptor().post(API_BASE + "/update-password", value),
  getAdminDetails: (value) =>
    AxiosInterceptor().get("/auth/profile", value),
  updateAdminProfile: (value) =>
    AxiosInterceptor().put(API_BASE + "/update-profile", value),
  changePassword: (value) =>
    AxiosInterceptor().post(API_BASE + "/update-password", value),
  getSetting: (value) =>
    AxiosInterceptor().get(API_BASE + "/setting/get-setting", value),
  updateSetting: (value) =>
    AxiosInterceptor().post(API_BASE + "/setting/update-setting", value),
};

export const userServices = {
  getUser: (values) => AxiosInterceptor().post(`/users`, values),
  getById: (id) => AxiosInterceptor().get(`/users/${id.id}`),
  // add: (values) => AxiosInterceptor().post(`/add-user`, values),
  edit: (value) => AxiosInterceptor().put(`/users/update-user/${value.id}`,value ),
  deleteUser: (value) => AxiosInterceptor().delete(`/users/delete-user/${value.id}`),
  changeStatus: (value) => AxiosInterceptor().put(`/users/update-user/${value.id}`,value ),
  blockUser: (value) => AxiosInterceptor().post(`users/block-user/${value.id}`),
};

export const CustomerSupport = {
  getAll: (values) => AxiosInterceptor().post(`/contact/get-contacts`, values?.isActive),
  response: (values) => AxiosInterceptor().post(`/contact/send-mail`, values),
};

export const subAdminServcie = {
  getUser: (values) => AxiosInterceptor().post(`/subadmin-record`, values),
  getById: (values) => AxiosInterceptor().post(`/user-by-id`, values),
  add: (values) => AxiosInterceptor().post(`/add-subadmin`, values),
  edit: (value) => AxiosInterceptor().post(`/edit-subadmin`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/delete-user`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/status`, value),
};

export const ticketServices = {
  getTicket: (values) =>
    AxiosInterceptor().post(`/ticket/get-all-ticket`, values),
  getById: (values) => AxiosInterceptor().post(`/ticket/get-by-id`, values),
  add: (values) => AxiosInterceptor().post(`/ticket/create-ticket`, values),
  edit: (value) => AxiosInterceptor().post(`/ticket/edit-ticket`, value),
  deleteTicket: (value) =>
    AxiosInterceptor().post(`/ticket/delete-ticket`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/ticket/update-status`, value),

  getCountries: (value) => AxiosInterceptor().get(`/location/countries`, value),
  getStatesByCountry: (value) =>
    AxiosInterceptor().post(`/location/states`, value),
  getCity: (value) => AxiosInterceptor().post(`/location/cities`, value),
};

export const sportsTeamServices = {
  getAll: (values) => AxiosInterceptor().post(`/team/get-all`, values),
  getById: (values) => AxiosInterceptor().post(`/team/get-one`, values),
  add: (values) => AxiosInterceptor().post(`/team/create`, values),
  edit: (value) => AxiosInterceptor().post(`/team/update`, value),
  deleteTicket: (value) => AxiosInterceptor().post(`/team/delete`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/team/status`, value),
};

export const AuctionServices = {
  getAuction: (values) =>
    AxiosInterceptor().post(`/auction/get-All-Auctions`, values),
  getById: (values) => AxiosInterceptor().post(`/auction/get-by-id`, values),
  add: (values) => AxiosInterceptor().post(`/auction/create-auction`, values),
  edit: (value) => AxiosInterceptor().post(`/auction/edit-auction`, value),
  deleteAuction: (value) =>
    AxiosInterceptor().post(`/auction/delete-auction`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/auction/update-status`, value),
  allTickets: (value) =>
    AxiosInterceptor().post(`/auction/slug-with-tickets `, value),
  allAuction: (value) =>
    AxiosInterceptor().post(`/auction/get-auction-details`, value),
  allTcketQuantity: (value) =>
    AxiosInterceptor().post(`/room/ticket/winners`, value),
  BiddingHistory: (value) =>
    AxiosInterceptor().post(`/room/ticket/bid-history-individual`, value),
};

export const bitPackageServices = {
  add: (values) => AxiosInterceptor().post(`/bidPackage/bid-package`, values),
  getBids: (values) =>
    AxiosInterceptor().post(`/bidPackage/get-bid-package`, values),
  getById: (values) =>
    AxiosInterceptor().post(`/bidPackage/get-single-bid-package`, values),
  edit: (value) =>
    AxiosInterceptor().post(`/bidPackage/update-bid-package`, value),
  deleteBid: (value) =>
    AxiosInterceptor().post(`/bidPackage/delete-bid-package`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/bidPackage/update-status`, value),
};

export const emailServices = {
  getEmail: (values) =>
    AxiosInterceptor().post(`/emailTemplate/getAllEmailTemplate`, values),
  addEmail: (value) =>
    AxiosInterceptor().post(`/emailTemplate/createEmailTemplate`, value),
  getByIdEmail: (values) =>
    AxiosInterceptor().post(`/emailTemplate/getEmailTemplateById`, values),
  editEmail: (value) =>
    AxiosInterceptor().post(`/emailTemplate/updateEmailTemplate`, value),
  deleteEmail: (value) =>
    AxiosInterceptor().post(`/emailTemplate/deleteEmailTemplate`, value),
  changeStatusEmail: (value) =>
    AxiosInterceptor().post("/emailTemplate/updateStatus", value),
};

export const apiCategory = {
  add: (value) => AxiosInterceptor().post(`/category/category`, value),
  edit: (value) => AxiosInterceptor().post(`/category/update-category`, value),
  delete: (value) =>
    AxiosInterceptor().post(`/category/delete-category`, value),
  getAll: (values) => AxiosInterceptor().post(`/category/categories`, values),
  getById: (values) =>
    AxiosInterceptor().post(`/category/single-category`, values),
  changeStatus: (value) =>
    AxiosInterceptor().post("/category/update-status", value),
  getAllSubCategory: (values) =>
    AxiosInterceptor().post(`/subcategory/getAllSubcategories`, values),
  addSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/add-subcategory`, value),
  editSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/edit-subcategory`, value),
  deleteSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/delete-subcategory`, value),
  getByIdSubCategory: (values) =>
    AxiosInterceptor().post(`/category/get-categories-in-parent`, values),
  changeStatusSubCategory: (value) =>
    AxiosInterceptor().post("/subcategory/update-status", value),
  category: (value) =>
    AxiosInterceptor().post("/category/categoriesDropdown", value),

  categorySports: (value) =>
    AxiosInterceptor().post("/category/sports/dropdown", value),
};

export const apiCms = {
  add: (value) => AxiosInterceptor().post(`/cms/create`, value),
  edit: (value) => AxiosInterceptor().post(`/cms/update`, value),
  delete: (value) => AxiosInterceptor().post(`/cms/delete`, value),
  getAll: (values) => AxiosInterceptor().post(`/cms/get-cms`, values),
  getById: (values) => AxiosInterceptor().post(`/cms/get-single-cms`, values),
  changeStatus: (value) => AxiosInterceptor().post("/cms/update-status", value),

  // Faq
  getFaq: (values) => AxiosInterceptor().post(`/faq/getFaq`, values),
  addFaq: (value) => AxiosInterceptor().post(`/faq/createFaq`, value),
  getByIdFaq: (values) => AxiosInterceptor().post(`/faq/getFaqById`, values),
  editFaq: (value) => AxiosInterceptor().post(`/faq/updateFaq`, value),
  deleteFaq: (value) => AxiosInterceptor().post(`/faq/deleteFaq`, value),
  changeStatusFaq: (value) =>
    AxiosInterceptor().post("/faq/updateFaqStatus", value),
};

export const AboutUsApi = {
  update: (value) => AxiosInterceptor().post(`/cms/about-us`, value),
  getById: (values) => AxiosInterceptor().get(`/cms/about-us`, values),
};

export const apiAdsBidFree = {
  add: (value) => AxiosInterceptor().post(`/video/create-video`, value),
  edit: (value) => AxiosInterceptor().post(`/video/edit-video`, value),
  delete: (value) => AxiosInterceptor().post(`/video/delete-video`, value),
  getAll: (values) => AxiosInterceptor().post(`/video/get-all-videos`, values),
  getById: (values) => AxiosInterceptor().post(`/video/get-by-id`, values),
  changeStatus: (value) =>
    AxiosInterceptor().post("/video/update-status", value),
};

export const NotificationServices = {
  getNotification: (value) =>
    AxiosInterceptor().get("/setting/get-notifications-setting", value),
  updateStatus: (value) =>
    AxiosInterceptor().post("/setting/update-notification-setting", value),
  getAll: (value) => AxiosInterceptor().get("/notify/get", value),
  getById: (value) => AxiosInterceptor().post("/notify/getById", value),
  update: (value) => AxiosInterceptor().post("/notify/update", value),
};

export const PlaceBidsServices = {
  getData: (value) => AxiosInterceptor().get("/task/placedBids/get", value),
  update: (value) => AxiosInterceptor().post("/task/dailyBidService", value),
};

export const ShareReferServices = {
  getData: (value) => AxiosInterceptor().get("/task/shareReferal/get", value),
  update: (value) => AxiosInterceptor().post("/task/socialShareReferal", value),
};

export const AutionBidsServices = {
  getData: (value) =>
    AxiosInterceptor().get("/task/purchaseAuctionTask/get", value),
  update: (value) =>
    AxiosInterceptor().post("/task/purchaseAuctionTask", value),
};
export const PaymentServices = {
  getData: (value) => AxiosInterceptor().post("/payments", value),
  update: (value) => AxiosInterceptor().post("/payments/update-status", value),
};
export const DashboardServices = {
  getData: (value) => AxiosInterceptor().post("/dashboard", value),
};

export const Teams = {
  getData: (value) => AxiosInterceptor().get("/team/dropdown", value),
};
